import { Flex, Box, Spinner } from "@chakra-ui/react";

export default function LoadableContent({
  children,
  minHeight = 0,
  color,
  showSpinner = true,
  showContent,
  ...rest
}) {
  const childrenVisibility = showContent ? "visible" : "hidden";
  return (
    <Box width="100%" position="relative" minHeight={minHeight} {...rest}>
      {!showContent && (
        <Flex
          justifyContent="center"
          alignItems="center"
          width="100%"
          position="absolute"
          height="100%"
        >
          {showSpinner && <Spinner color={color} />}
        </Flex>
      )}
      <Box visibility={childrenVisibility}>{children}</Box>
    </Box>
  );
}
